export default "__VITE_ASSET__CtKyl9Up__"